import { render, staticRenderFns } from "./HistoryPickup.vue?vue&type=template&id=3503d59e&"
import script from "./HistoryPickup.vue?vue&type=script&lang=js&"
export * from "./HistoryPickup.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPickup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports